import posthog from 'posthog-js';

// Global singleton to prevent double initialization
let isInitialized = false;

export const initTelemetry = () => {
  if (isInitialized) return;
  
  const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
  const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com';

  if (!POSTHOG_KEY) {
    console.warn('PostHog telemetry skipped: VITE_POSTHOG_KEY is missing.');
    return;
  }

  // Initialize PostHog
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only', // Only capture for identified users (saves free tier)
    autocapture: true, // Captures clicks, pageviews automatically
    capture_pageview: false, // We'll handle this manually for React Router if needed, but true is okay for SPA. Let's let autocapture do it.
    session_recording: {
        maskAllInputs: true, // ✨ PRIORITY PRIVACY: Mask all input fields
        maskTextSelector: '.ph-no-capture', // ✨ PRIORITY PRIVACY: Blur specific text
    }
  });

  isInitialized = true;
  console.log('PostHog telemetry initialized');
};

/**
 * Identify a user across sessions. Call this after Auth login.
 */
export const identifyUser = (uid, properties = {}) => {
  if (!isInitialized) return;
  posthog.identify(uid, properties);
};

/**
 * Opt-out capture if user requests GDPR compliance.
 */
export const optOutCapture = () => {
  if (!isInitialized) return;
  posthog.opt_out_capturing();
};

/**
 * Manually capture a specific UX event (with properties)
 */
export const logEvent = (eventName, properties = {}) => {
  if (!isInitialized) return;
  posthog.capture(eventName, properties);
};

export default posthog;
